import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworkProviderBuilderRegistry } from '@dynamic-labs-sdk/client/core';

import { createTronNetworkProvider } from '../utils/createTronNetworkProvider';

export const registerTronNetworkProviderBuilder = (
  client: DynamicClient
): void => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  // If the Tron network provider builder is already registered, return.
  if (networkProviderBuilderRegistry.get().get('TRON')) {
    return;
  }

  networkProviderBuilderRegistry.register({
    builder: createTronNetworkProvider,
    chain: 'TRON',
  });
};
